// extracted by mini-css-extract-plugin
export default {"confirmation":"SettingsSubmitConfirmation-module__confirmation--hMkoN","fadeOut":"SettingsSubmitConfirmation-module__fadeOut--iXrML"};